<template lang="pug">
main.mg-wrap
  .mg-align(v-if="is_game_load")
    Intro
    Game(v-if="isShowGame", @showTopUp="showTopUp", @show404="show404")
    .mg-mobile(v-else)
      span {{ $t('error.no_mobile') }}

  notifications(group="collection")

</template>

<script>
import "@/assets/global/styles/index.styl";

import getStoreModuleByName from "@mrg_minigames/common/helpers/store/getStoreModuleByName";
import { createNamespacedHelpers } from "vuex";

const mg_global = getStoreModuleByName("global");
const { mapState } = createNamespacedHelpers(mg_global);

import env from "@chronos/frontend-base/src/libs/tools/Environment";

import MobileDetectionMixin from "@chronos/frontend-base/src/mixins/mobile_detection/MobileDetectionMixin";

import Intro from "@/components/blocks/intro/Intro.vue";
import Game from "@/components/blocks/game/Game.vue";

export default {
  name: "Collection",

  components: {
    Intro,
    Game,
  },

  mixins: [MobileDetectionMixin],

  props: {
    activityInfo: Object,
  },

  data() {
    return {
      is_game_load: false,
    };
  },

  computed: {
    ...mapState(["is_active", "current_time", "starts_at", "acquirable_until_time"]),
    getPage404() {
      return `${env.getHomePage()}404`;
    },
    isShowGame() {
      return this.document_width >= 620;
    },
  },

  mounted() {
    this.getInitGame();
  },

  methods: {
    getInitGame() {
      this.$store.commit(`${mg_global}/initGameData`, this.activityInfo);

      this.$store.dispatch(`${mg_global}/getImageIds`, this.activityInfo.rows)
        .then(() => this.$store.dispatch(`${mg_global}/getProgress`))
        .then((response) => {
          if (
            this.isTestingMode(response.data) ||
            (typeof this.activityInfo.is_active === "boolean" &&
              !this.activityInfo.is_active) ||
            this.activityInfo.current_time < this.activityInfo.starts_at ||
            this.activityInfo.current_time >= this.activityInfo.acquirable_until_time
          ) {
            this.show404();
          } else {
            this.is_game_load = true;
          }
        });
    },

    isTestingMode(data) {
      return data.error && data.error.code === 11429;
    },

    showTopUp() {
      this.$emit("showTopUp");
    },
    show404() {
      document.location.href = this.getPage404;
    },
  },
};
</script>
